import { useParams } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import { AppLoader, LoaderType } from 'components/AppLoader'
import moment from 'moment'
import { useGetCostHistoryQuery } from 'core/api/CostHistoryApi'
import { ICostHistoryItem } from 'core/api/dto/CostHistoryDto'
import { useEffect, useMemo } from 'react'
import { AppTableMobile } from 'components/AppTable/AppTableMobile'

export const PriceHistoryTab = () => {
  const { dishId } = useParams()
  const [searchParams, setSearchParams] = useSearchParams()

  const limit = Number(searchParams.get('limit')) || 15

  useEffect(() => {
    if (!searchParams.get('limit')) {
      searchParams.set('limit', '15')
      setSearchParams(searchParams, { replace: true })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const queryParams = useMemo(() => {
    return {
      dishId: Number(dishId!),
      ordering: '-created_at',
      limit,
    }
  }, [dishId, limit])

  const {
    data: priceHistory,
    isLoading,
    isFetching,
  } = useGetCostHistoryQuery(queryParams, { skip: !dishId })

  const headerData = [
    { title: 'Старая цена', colWidth: '20%' },
    { title: 'Новая цена', colWidth: '20%' },
    { title: 'Инициатор', colWidth: '35%' },
    { title: 'Дата/время', colWidth: '25%' },
  ]

  const tableDataSelectors = [
    {
      renderItem: (item: ICostHistoryItem) => (
        <div>{item.oldCost !== null ? `${item.oldCost}р.` : '-'}</div>
      ),
    },
    {
      renderItem: (item: ICostHistoryItem) => (
        <div>{item.newCost !== null ? `${item.newCost}р.` : '-'}</div>
      ),
    },
    {
      renderItem: (item: ICostHistoryItem) => (
        <div>{item.user?.username || '-'}</div>
      ),
    },
    {
      renderItem: (item: ICostHistoryItem) => (
        <div>{moment.parseZone(item.createdAt).format('DD.MM.YYYY/HH:mm')}</div>
      ),
    },
  ]

  if (isLoading) {
    return <AppLoader loaderType={LoaderType.aiTable} />
  }

  if (!priceHistory) return null

  return (
    <div className="tab-content">
      <h2>История стоимости:</h2>
      <AppTableMobile
        data={priceHistory}
        headerData={headerData}
        tableDataSelectors={tableDataSelectors}
        tableClassName="price-history-table"
        isLoading={isFetching}
        idName="price-history"
        paginationStep={15}
        emptyText="История стоимости отсутствует"
      />
    </div>
  )
}
